import React from 'react';
import { Col, Row, Container, Stack } from 'react-bootstrap'
import logo from "../../assests/LOGO.png"
import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css';

const Footer = () => {
    return (
        <div className='bg-light'>
            <Container>
                <Row className='footer'>
                    <Col className="logo" lg="2">
                        <img src={logo} width={100}/>
                    </Col>
                    <Col lg="4">
                        <h3 className='footer-heading'>Quick Links</h3>
                        <Row>
                            <Col>
                                <p><a className='quicklink' href="/about-us">About Us</a></p>
                                <p><a className='quicklink' href="/about-us">Contact Us</a></p>
                                <p className='iconlinks'><a className='quicklink' href="/product/coverall">Body Protection</a></p>
                                <p><a className='quicklink' href="/product/masks">Breath Protection</a></p>
                                <p><a className='quicklink' href="/product/eyewear">Eye Protection</a></p>
                            </Col>
                            <Col>
                                <p><a className='quicklink' href="/product/boots">Foot Protection</a></p>
                                <p><a className='quicklink' href="/product/hats">Heat Protection</a></p>
                                <p><a className='quicklink' href="/product/gloves">Hand Protection</a></p>
                                <p><a className='quicklink' href="/boot">Road Safety</a></p>
                                <p><a className='quicklink' href="/product/coverall#FireRetardant">Fire Retardant Coverall</a></p>
                            </Col>
                            <Col>
                                <p><a className='quicklink' href="/hat">Hat</a></p>
                                <p><a className='quicklink' href="/hi-vis-clothing">High Visibility Clothing</a></p>
                                <p><a className='quicklink' href="/glasses">Glasses</a></p>
                                <p><a className='quicklink' href="/gloves/leather">Leather Gloves</a></p>
                            </Col>
                        </Row>
                    </Col>
                    <Col className='links' lg="3">
                        <h3 className='footer-heading'>Company Offices</h3>
                        <p><strong>Headquater:</strong> P-2712, Street #16/20, Mansoorabad, Faislabad, Pakistan</p>
                        <p><strong>Office:</strong> 26 Curlew way, Inverkeithing, KY11 1FG, United Kingdom</p>
                    </Col>
                    <Col className="contact-details" lg="3">
                        <h3 className='footer-heading'>Contact Details</h3>
                        <p><strong>Headquater: </strong> +923008652471</p>
                        <p><strong>Customer Care: </strong> +447413402742</p>
                        <p><strong>Email:</strong><a className='quicklink' href='mailto:muddasir@shareeftex.com'> muddasir@shareeftex.com</a></p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;